import JsFunction from './JsFunction';

export default class DeleteFunction extends JsFunction {
  outputTemplate = (attr, htmlElement) =>
    `document.querySelector(['annotationname = ${attr}']).${htmlElement} = response.body.query.${attr} ;`;

  nextFunction;

  apiCallPromisified = '';

  entityName = '';

  importModelParameter = [];

  modelNames = [];

  attributeArray = [];

  effectingHtmlElements = {};

  constructor(method, annotations, htmlDom) {
    super(method, annotations);
    this.inputHtmlElement = method.inputHtmlElement || '';
    this.htmlNames = method.entityAttributes || '';
    this.apiCallPromisified = method.apiCallPromisified || '';
    this.entityName = method.entityName || '';
    this.importModelParameter = method.importModelParameter || [];
    this.modelNames = method.modelNames || [];
    this.attributeArray = this.getMapOfEntitiesToAttributes().get(method.entityName) || [];
    this.effectingHtmlElements = this.getTheHtmlElements(this.attributeArray, htmlDom) || {};
  }

  printImportStatement() {
    return this.apiInstance + this.importStatement + this.importModelParameter;
  }

  readTheUrlAsJsCommad() {
    return `let ${this.entityName}Id = window.location.pathname.replace('/${this.pageName}/','');`;
  }

  findIfCompBelongToGetAllComp(){
    return `
      if(${this.entityName}Id === '/${this.pageName}' || ${this.entityName}Id === ''){
        let parentId = "";
        const storedData = window.localStorage.getItem('data');
        const newMap = new Map(JSON.parse(storedData));
        newMap.forEach((value, key) => {
          if (
            document
              .getElementById(key)
              .contains(document.getElementById("${this.compId}")) === true &&
              document.getElementById(key).contains(document.getElementById(parentId)) === false
          ) {
            ${this.entityName}Id = value._id;
            parentId = key;
          }
        });
      }
    `
  }

  printFunction() {
    this.functionality += this.readTheUrlAsJsCommad();
    this.functionality += this.findIfCompBelongToGetAllComp();
    this.functionality += this.apiCallPromisified;
    this.printNextFunctionCode();
    super.clearfunctionNextTemplate();
    return this.functionality;
  }

  printNextFunctionCode() {
    if (this.nextFunction)
      this.functionality = this.functionality.replace(
        this.functionNextTemplate,
        this.nextFunction.printFunction()
      );
  }

  getTheHtmlElements(attributeArray, htmlDom) {
    return attributeArray.reduce((obj, attribute) => {
      const htmlTag =
        htmlDom.querySelector(`[annotationname = '${attribute}']`)?.tagName.toLowerCase() || '';
      const htmlAttr = this.htmlTagsToAttributes.get(htmlTag) || '';
      if (!htmlAttr) return { ...obj };
      return { ...obj, [attribute]: htmlAttr };
    }, {});
  }

  returnParametesFromHtmlElements() {
    let js = '';
    js = this.attributeArray.reduce((acc, attribute) => {
      if (this.effectingHtmlElements[attribute])
        acc += this.outputTemplate(attribute, this.effectingHtmlElements[attribute]);

      return acc;
    }, '');
    return js;
  }
}
